/****************************************************
 * Module Name:  sendToRecheckModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import { Box, Button, Typography } from "@mui/material";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import logo from '../../images/pansuriya.jpg'
import { LoadingButton } from "@mui/lab";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import dayjs from "dayjs";

function SendToReCheckModal({
  show,
  setShow,
  handleValidation,
  handleSave,
  stoneId,
  sourceData,
  status,
  loading
}) {
  const [showError, setShowError] = useState(false);

  const prepareStoneData = () => {
    const selectionSet = new Set(stoneId);
    const listdata = sourceData
      .filter(({ stoneid }) => selectionSet.has(stoneid))
      .map(({ stoneid, consignmentno, consignmentdate, status: oldstatus }) => {

        return {
          stoneid,
          consignmentno,
          consignmentdate: consignmentdate ? dayjs(consignmentdate).format('YYYY-MM-DD') : null,
          consignmentfrom: Constants.loggedInUser.locationid,
          oldstatus,
          newstatus: status,
        };
      });
    return listdata;
  };

  const saveHandler = () => {

    let data = prepareStoneData();

    if (handleSave) {
      if (handleValidation) {
        if (handleValidation(data)) {
          //need to add locId here and in the parent component if need for validation
          handleSave(data);
        } else {
          setShowError(true);
        }
      } else {
        handleSave(data);
      }
    }
  };

  const closeErrorDialog = () => {
    setShowError(false);
  };

  const handleClose = () => {
    setShow(false);
  };
  return (
    <div>
      <TabMenuSnackbar
        show={showError}
        message={
          <Box>
            Send to location validation Failed
            <br /> Please enter correct data
          </Box>
        }
        variant={"error"}
        autoHide={false}
        handleClose={closeErrorDialog}
        title="Validation Failure"
      />
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={true}
        size="lg"
        centered
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;
            {status === "RE-CHECK_SENT"
              ? "Send For Re-Check"
              : "Mark as Re-Check_Done"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Typography variant="h6" sx={{ textAlign: "center" }}>
            Are you sure you want to{" "}
            {status === "RE-CHECK_SENT"
              ? "send these stones for Re-Check"
              : "mark these stones as Re-Check_Done"}{" "}
            ?
          </Typography>
        </Modal.Body>
        <Modal.Footer>
          <Box sx={{
            "& .Mui-disabled": {
              backgroundColor: "rgba(0, 0, 0, 0.12) !important",
              color: "rgba(0, 0, 0, 0.26) !important"
            }
          }}>
            <LoadingButton
              variant="contained"
              onClick={saveHandler}
              type="Submit"
              sx={{ mr: 3 }}
              loading={loading}
              loadingPosition="start"
              startIcon={<SendRoundedIcon size="large" />}
            >
              {status === "RE-CHECK_SENT" ? "Send" : "Mark"}
            </LoadingButton>
          </Box>
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            sx={{ mr: 2 }}
            disabled={loading}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default SendToReCheckModal;
